import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../../../shared/configurations/configurations.factory';
import { Configurations } from '../../../shared/configurations/models/configurations.model';
import { ApiEnumerationModel } from '../DTOs/base-DTOs/api-enumeration-model.dto';
import { ApiObjectModel } from '../DTOs/base-DTOs/api-object-model.dto';
import { BusinessSectorDto } from '../DTOs/business-sector.dto';

@Injectable({
  providedIn: 'root'
})
export class BusinessSectorProxyService {

  private readonly baseUrl: string

  constructor(@Inject(APP_CONFIG) config: Configurations, private readonly httpClient: HttpClient) {
    this.baseUrl = config.environmentConfig.lobbyBaseUrl + '/businessSector'
  }

  getBusinessSectorById$(id: number): Observable<ApiObjectModel<BusinessSectorDto>> {
    return this.httpClient.get<ApiObjectModel<BusinessSectorDto>>(this.baseUrl + `/${id}`)
  }

  searchBusinessSector$(includeDeleted: boolean | undefined = undefined, businessSectorId: number | undefined = undefined): Observable<ApiEnumerationModel<BusinessSectorDto>> {
    let query: string = ''

    if (includeDeleted) query = query + `${query ? '&' : ''}includeDeleted=${includeDeleted}`
    if (businessSectorId) query = query + `${query ? '&' : ''}businessSectorId=${businessSectorId}`

    return this.httpClient.get<ApiEnumerationModel<BusinessSectorDto>>(this.baseUrl + `${query ? '?' : ''}${query}`)
  }
}
